import { render, staticRenderFns } from "./BedList.vue?vue&type=template&id=2e4c18b5&scoped=true"
import script from "./BedList.vue?vue&type=script&lang=js"
export * from "./BedList.vue?vue&type=script&lang=js"
import style0 from "./BedList.vue?vue&type=style&index=0&id=2e4c18b5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4c18b5",
  null
  
)

export default component.exports